import { Ipad, Service, ServiceSignature } from "./_models";

export class AccountFast {
    unique_identifier: string;
    name: string;
    fast_billing: {
        is_subscribed: boolean;
        enable_free_access: boolean;
        manually_disabled_free_trial?: boolean
        stripe_subscription_cancel_at?: number | null;
    };
    belongs_to_agency?: AgencyFast | null;

    constructor(data: any) {
        this.unique_identifier = data.unique_identifier;
        this.name = data.name;
        this.fast_billing = data.fast_billing;
        this.belongs_to_agency = data.belongs_to_agency ? new AgencyFast(data.belongs_to_agency) : null;
    }
}

export class AgencyFast {
    unique_identifier: string;
    name: string;
    payment_out_of_date: boolean;

    constructor(data: any) {
        this.unique_identifier = data.unique_identifier;
        this.name = data.name;
        this.payment_out_of_date = data.payment_out_of_date || false;
    }
}

export class UserFast {
    unique_identifier: string;
    email: string;
    name: string;
    name_initials: string;
    confirmed_at: string;
    inserted_at: string;
    updated_at: string;
    is_superuser: boolean;
    is_super_super_user: boolean;
    belongs_to_agency?: AgencyFast | null; // Optional, as not all users belong to an agency
    is_agency_admin?: boolean; // Optional, for agency admins
    public_data: { 
        name: string;
        is_marketing_lead?: boolean;
        needs_onboarding?: boolean;
        [key: string]: any; // Allow additional properties
    };

    constructor(data: any) {
        this.unique_identifier = data.unique_identifier;
        this.email = data.email;
        this.name = data.name;
        this.name_initials = data.name_initials;
        this.confirmed_at = data.confirmed_at;
        this.inserted_at = data.inserted_at;
        this.updated_at = data.updated_at;
        this.is_superuser = data.is_superuser;
        this.is_super_super_user = data.is_super_super_user;
        this.belongs_to_agency = data.belongs_to_agency ? new AgencyFast(data.belongs_to_agency) : null;
        this.is_agency_admin = data.is_agency_admin || false;
        this.public_data = data.public_data;
    }
}

export class UserAccountMembershipFast {
    unique_identifier: string;
    account: AccountFast;

    constructor(data: any) {
        this.unique_identifier = data.unique_identifier;
        this.account = new AccountFast(data.account);
    }
}

export class SignatureFast extends ServiceSignature {
    // No additional implementation needed; inherits everything from ServiceSignature
}

export class ServiceFast extends Service {
    // No additional implementation needed; inherits everything from Service
}


export class IpadFast extends Ipad {
    // No additional implementation needed; inherits everything from Ipad
}

export class UserWithMembershipsFast {
    user: UserFast
    memberships: UserAccountMembershipFast[]

    constructor(data: any) {
        this.user = new UserFast(data.user)
        this.memberships = data.memberships.map((membership: any) => new UserAccountMembershipFast(membership)).sort((a: UserAccountMembershipFast, b: UserAccountMembershipFast) => {
            if (a.account.name < b.account.name) {
                return -1
            }
            if (a.account.name > b.account.name) {
                return 1
            }
            return 0
        })
    }
}
